/**
 * @generated SignedSource<<0aef035037849f1a028e1af06561ecc6>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PLUProductItem_PLUProduct$data = {
  readonly id: string;
  readonly " $fragmentSpreads": FragmentRefs<"PLUProductItemBody_PLUProduct" | "PLUProductItemFooter_PLUProduct">;
  readonly " $fragmentType": "PLUProductItem_PLUProduct";
};
export type PLUProductItem_PLUProduct$key = {
  readonly " $data"?: PLUProductItem_PLUProduct$data;
  readonly " $fragmentSpreads": FragmentRefs<"PLUProductItem_PLUProduct">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PLUProductItem_PLUProduct",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PLUProductItemFooter_PLUProduct"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PLUProductItemBody_PLUProduct"
    }
  ],
  "type": "PLUProduct",
  "abstractKey": null
};

(node as any).hash = "0d61eba091609a54d0dd182479fe1b09";

export default node;
